module.exports = __webpack_public_path__ + "img/bo.488696b.svg";